var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShown)?_c('div',{staticClass:"loading-screen",attrs:{"id":"LoadingScreen"}},[_c('div',{staticClass:"spinner-box"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"90","width":"4"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }